import React from 'react'
import PropTypes from "prop-types"
import { bem } from '../../helpers'

const Row = (props) => {
  const {children, rowType, className} = props
  return (
    <tr className={bem("table", `${rowType}__row`, [], className)}>
      {children}
    </tr>
  )
}

Row.propTypes = {
  children: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.element, PropTypes.string, PropTypes.number])),
  className: PropTypes.string,
  rowType: PropTypes.oneOf(["head", "body"])
}

Row.defaultProps = {
  rowType: "body"
}

export default Row
